<other-person [(form)]="form"></other-person>